import React from 'react';
import Layout from 'layouts/member/Layout';
import { useTranslation } from 'react-i18next';

import CheckBox from 'components/CheckBox';
import CheckBoxGroup from 'components/CheckBoxGroup';
import SelectBox from 'components/SelectBox';
import TextBox from 'components/TextBox';
import TextAreaBox from 'components/TextAreaBox';
import SubmitButton from 'components/SubmitButton';

const SelectOptions = [
  { value: 'option1', label: 'Option 1' },
  { value: 'option2', label: 'Option 2' },
  { value: 'option3', label: 'Option 3' },
];

const SampleForm: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <h1>{t('pages.member.sample_form')}</h1>
      <br />
      <hr />
      <br />
      <h1>Check Box</h1>
      <div className="flex items-start gap-4 mb-2">
        <label className="checkbox-label">
          Sample CheckBox Label
        </label>
        <div className="flex flex-col">
          <CheckBox id="checkbox-sample1" name="checkbox-sample">
            Sample CheckBox Label1
          </CheckBox>
          <CheckBox id="checkbox-sample2" name="checkbox-sample">
            Sample CheckBox Label2
          </CheckBox>
        </div>
      </div>
      <div className="mb-2">
        <CheckBoxGroup
          options={[
            { id: 'checkbox-group-sample1', label: 'Sample CheckBox Group1' },
            { id: 'checkbox-group-sample2', label: 'Sample CheckBox Group2' },
          ]}
          title="Sample CheckBox Group"
          name="checkbox-group-sample1"
        />
        <CheckBoxGroup
          options={[
            { id: 'checkbox-group-sample2-1', label: 'Sample CheckBox Group1' },
            { id: 'checkbox-group-sample2-2', label: 'Sample CheckBox Group2' },
          ]}
          title="Sample CheckBox Group2"
          name="checkbox-group-sample2"
        />
      </div>
      <br />
      <br />
      <hr />
      <br />
      <h1>Select Box</h1>
      <div className="w-1/2 mb-2">
        <SelectBox
          id="selectbox-sample1"
          options={SelectOptions}
          value="option1"
          label="Sample Select Box"
          placeholder={t('components.selectBox.placeholder')}
        />
      </div>
      <div className="mb-2">
        <SelectBox
          id="selectbox-sample2"
          options={SelectOptions}
          value=""
          label="Sample Select Box2"
          placeholder={t('components.selectBox.placeholder')}
          isFlat={true}
        />
      </div>
      <div className="w-1/2 mb-2">
        <SelectBox
          id="selectbox-sample3"
          options={SelectOptions}
          value=""
          label="Sample Select Box3(Disabled)"
          placeholder={t('components.selectBox.placeholder')}
          disabled={true}
        />
      </div>
      <br />
      <hr />
      <br />
      <h1>Input Text Box</h1>
      <div className="w-1/2 mb-2">
        <TextBox
          id="textbox-sample1"
          value="Sample Text"
          label="Sample Text Box"
          placeholder={t('components.textBox.placeholder')}
        />
      </div>
      <div className="mb-2">
        <TextBox
          id="textbox-sample2"
          value=""
          label="Sample Text Box2"
          placeholder={t('components.textBox.placeholder')}
          isFlat={true}
        />
      </div>
      <div className="w-1/2 mb-2">
        <TextBox
          id="textbox-sample3"
          value="Sample Text"
          label="Sample Text Box3(Disabled)"
          placeholder={t('components.textBox.placeholder')}
          disabled={true}
        />
      </div>
      <br />
      <hr />
      <br />
      <h1>TextArea Box</h1>
      <div className="w-1/2 mb-2">
        <TextAreaBox
          id="textarea-sample1"
          value="Sample Text Area"
          label="Sample Text Area Box"
          placeholder={t('components.textAreaBox.placeholder')}
        />
      </div>
      <div className="mb-2">
        <TextAreaBox
          id="textarea-sample2"
          value=""
          label="Sample Text Area Box"
          placeholder={t('components.textAreaBox.placeholder')}
          rows={5}
          isFlat={true}
        />
      </div>
      <div className="w-1/2 mb-2">
        <TextAreaBox
          id="textarea-sample3"
          value="Sample Text Area"
          label="Sample Text Area Box"
          placeholder={t('components.textAreaBox.placeholder')}
          disabled={true}
        />
      </div>
      <br />
      <hr />
      <br />
      <h1>Submit Button</h1>
      <div className="w-1/2 mb-2">
        <SubmitButton
          onClick={() => alert('Submitted!')}
        >
          Submit
        </SubmitButton>
      </div>
    </Layout>
  );
};

export default SampleForm;